import {
  AppearanceSettings,
  ArchivedChatsSettings,
  AutoReviewSettings,
  BackendSettings,
  BrowserSettings,
  ChannelsSettings,
  ChatSettings,
  DataAndPrivacySettings,
  DictationSettings,
  GeneralSettings,
  HummingbirdSettingsSection,
  ImportSettings,
  IntegrationSettings,
  JournalSettings,
  KeyboardShortcutsSettings,
  McpClientsSettings,
  MeetingsSettings,
  PrivacyControlsSettings,
  ProactiveAgentSettings,
  ProactivitySettings,
  SubscriptionSettings,
  SupportSettings,
  SystemsSettings,
  TeamDashboardSettings,
  UsageSettings,
  VoiceModeSettings,
  WebhooksSettings,
} from './sub-settings';

export const settingsSections = {
  General: GeneralSettings,
  Chat: ChatSettings,
  ArchivedChats: ArchivedChatsSettings,
  Support: SupportSettings,
  Appearance: AppearanceSettings,
  KeyboardShortcuts: KeyboardShortcutsSettings,
  Meetings: MeetingsSettings,
  PrivacyControls: PrivacyControlsSettings,
  DataControls: DataAndPrivacySettings,
  Integrations: IntegrationSettings,
  McpClients: McpClientsSettings,
  Import: ImportSettings,
  System: SystemsSettings,
  Hummingbird: HummingbirdSettingsSection,
  Dictation: DictationSettings,
  Journal: JournalSettings,
  Subscription: SubscriptionSettings,
  Usage: UsageSettings,
  Team: TeamDashboardSettings,
  Channels: ChannelsSettings,
  Webhooks: WebhooksSettings,
  VoiceMode: VoiceModeSettings,
  Proactivity: ProactivitySettings,
  AutoReview: AutoReviewSettings,
  ProactiveAgent: ProactiveAgentSettings,
  Browser: BrowserSettings,
  Backend: BackendSettings,
};

export type SettingsSection = keyof typeof settingsSections;

export const isSettingsSection = (value: string): value is SettingsSection =>
  Object.hasOwn(settingsSections, value);
